import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import PaymentMethodItem from 'components/payment/PaymentMethodItem';
import { ErrorContext } from 'containers/aio/PaymentMethodsContainer/context';
import { useAppDispatch, useAppSelector } from 'lib/hooks/redux';
import { useDeliveryMethod } from 'lib/hooks/deliveryMethod';
import { useRules } from 'lib/hooks/rules';
import { useDisabledMessage } from 'lib/hooks/disabledMessage';
import { setPaymentMethod as setOrbis } from 'store/paymentMethod/orbis.slice';
import { RootState } from 'types/store';

const instructionMessage: JSX.Element = (
    <>
        Paga tu código PagoEfectivo:
        <ol>
            <li style={{ marginBottom: '20px' }}>
                Haz clic en <strong>“Reservar”</strong>, luego copia el{' '}
                <strong>“código de pago”</strong> que te enviaremos al correo.
            </li>
            <li style={{ marginBottom: '20px' }}>
                Puedes hacer el pago por <strong>Banca Móvil, Internet</strong> de tu banca con la
                opción pago de servicios y/o tambien en <strong>agentes y bodegas</strong>{' '}
                autorizadas.
            </li>
            <li style={{ marginBottom: '20px' }}>
                PagoEfectivo esta disponible sólo para compras{' '}
                <strong>inferiores a S/1O,000.</strong>
            </li>
            <ul>
                Realiza el pago antes de los siguientes <strong>30 min.</strong> ¡No dejes que se
                cancele tu compra!
            </ul>
        </ol>
    </>
);

export const OrbisSelector: React.FC = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation('error');
    const [openCollapsible, setOpenCollapsible] = useState<boolean>(false);
    const pm = useAppSelector((state) => state.paymentMethod);
    const dm = useDeliveryMethod();
    const rules = useRules();
    const ctx = useContext(ErrorContext);
    const isAvailable = pm.types.orbis.available;
    const couponLoading = useAppSelector(
        (state: RootState) => state.coupon.status === 'pending' || state.cart.status !== 'ok',
    );

    const isLoading = pm.data.loading.includes('Orbis');
    const isSelected = pm.data.selected.includes('Orbis');
    const isBlocked =
        (pm.data.status === 'pending' && !isLoading) || couponLoading || !dm.hasSchedules();
    const disabledMessage = useDisabledMessage().find((dm) => dm.paymentMethod === 'Orbis')
        ?.disabledMessage;

    useEffect(() => {
        if (!isSelected) {
            setOpenCollapsible(false);
        }
    }, [isSelected]);

    async function setOrbisPayment() {
        try {
            if (!openCollapsible) {
                setOpenCollapsible(!openCollapsible);
                await dispatch(setOrbis(true)).unwrap();
            } else {
                setOpenCollapsible(false);
            }
        } catch (e) {
            setOpenCollapsible(false);
            ctx.setError(t('defaultPaymentError.message'));
        }
    }

    return (
        <PaymentMethodItem
            paymentMethodName="PagoEfectivo"
            type="orbis"
            widthIcon="60px"
            onClick={setOrbisPayment}
            selected={isSelected}
            blocked={isBlocked}
            isLoading={isLoading}
            haveCollapse={true}
            openCollapsible={openCollapsible}
            instructionMessage={instructionMessage}
            disabled={disabledMessage || !rules.feature('Orbis') || !isAvailable}
        />
    );
};
